import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { SendEmailForm } from './use-send-email.form';

export const useSendEmailFormContext = ():
  | UseFormReturn<SendEmailForm>
  | never => {
  const form = useFormContext<SendEmailForm>();

  if (form === null)
    throw AppError.hookScopeError('useSendEmailFormContext error.');

  return form;
};
